<template lang="pug">
  div.wrap-atom-user-reaction
    div(:class="bubbleShape"
      :style="`transform: scale(${messageScale});`").message
      div(:class="{'active': messageIsActive}").wrap-message.f.fc
        div(v-if="latestMessage").bubble.px10.py8
          span.text-center.block.fz11 {{this.latestMessage.value}}
    div(v-for="sound in emortSounds"
      v-if="currentPlayingEmortSound && sound.id === currentPlayingEmortSound.id"
      :style="`transform: scale(${soundIconScale});`").wrap-playing-sound-icon.f.fc
      span(:class="playingSoundIconAnimation").fz16 {{currentPlayingEmortSound.emoji}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/animation.scss";

.wrap-atom-user-reaction {
  .message {
    .wrap-message {
      position: absolute;
      // width: 100%;
      width: 160px;
      left: 50%;
      margin-left: -80px;
      z-index: 100;
      .bubble {
        position: relative;
        span {
          letter-spacing: 1.4px;
          // color: $primary_bg_color;
        }
      }
    }
  }
  .wrap-playing-sound-icon {
    position: absolute;
    width: 40px;
    left: 50%;
    bottom: 80%;
    margin-left: -20px;
    z-index: 100;
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import { msgPopSounds, emortSounds } from '@/components/utils/sounds'

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    userMessages: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      // messages: [],
      latestMessage: null,
      messageIsActive: false,
      messageActiveTimer: null,
      bubbleShape: '',
      messageScale: 1.0,
      emortSounds: [],
      msgPopSounds: [],
      currentPlayingEmortSound: null,
      soundIconScale: 1.0
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    async user (newUser, oldUser) {
      let self = this
      if (oldUser && newUser.playingSound) {
        if (!oldUser.playingSound
          || (newUser.playingSound.playedAt.toDate() - oldUser.playingSound.playedAt.toDate() > 400 )) {
          this.playEmortSound()
        }
      }
    },
    messages (newMessages, oldMessages) {
      if ((newMessages[0] && !oldMessages)
      || (oldMessages[0] && newMessages[0].id !== oldMessages[0].id)) {
        this.updateUserMessages()
      }
    }
    // userMessages (newMessages, oldMessages) {
    //   // // initializeされていたら
    //   // if (oldMessages) {
    //   // }
    //   // if (newMessages[0] && oldMessages[0]
    //   //  && newMessages[0].id !== oldMessages[0].id) {
    //   console.log(this.uid, newMessages[0])
    //   if ((newMessages[0] && !oldMessages)
    //   || (oldMessages[0] && newMessages[0].id !== oldMessages[0].id)) {
    //     this.updateUserMessages()
    //   }
    // }
  },
  created () {
    // database.userCollection().getMessageInRealtime(this.user.id, this.updateMessages)

    this.emortSounds = emortSounds.map(e => {
      return { ...e, isPlaying: false }
    })
    this.msgPopSounds = msgPopSounds.map(e => {
      return { ...e, isPlaying: false }
    })
  },
  mounted () {
    // 非表示ではあるけどlatestReactingUsersだった場合
    if (this.messages[0] && this.messages[0].createdBy === this.user.uid
     && ((new Date() - this.messages[0].createdAt.toDate()) < 5000 )) {
    // if (this.messages[0] && this.messages[0].createdBy === this.user.uid) {
      this.updateUserMessages()
    }
  },
  methods: {
    async updateUserMessages () {
      // if (!this.isInitialized) {
      //   this.isInitialized = true
      //   return
      // }

      // this.setZIndex()
      if (this.messages[0].createdBy !== this.user.uid) return

      if (this.messages[0].class === 'sound') {
        this.playEmortSound(this.messages[0])
        return
      }

      this.messageIsActive = false

      // const distance = this.getDistanceFromMe()

      // const messageScale = 1.2 - distance / 300
      // console.log('messageScale', messageScale)
      // if (messageScale < 0.1) return

      await this.sleep(400)
      this.$emit('setIconAnimation', '')
      this.bubbleShape = `shape-${this.messages[0].type}`
      // this.bubbleShape = `shape-${this.user.bubbleType}`

      await this.sleep(100)
      // this.messageScale = messageScale
      this.latestMessage = this.messages[0]
      this.$emit('setIconAnimation', this.messages[0].type)
      // this.$emit('setIconAnimation', this.user.bubbleType)
      this.messageIsActive = true

      // play sounds
      // const msgPopSoundVol = ((0.5 - distance / 300) > 0.1) ?
      //   0.5 - distance / 300 : 0.1
      const msgPopSoundVol = 0.5
      this.$emit('playMsgPopSound', {
        id: this.latestMessage.type,
        volume: msgPopSoundVol
      })

      clearTimeout(this.messageActiveTimer)
      this.messageActiveTimer = setTimeout(() => {
        this.latestMessage = ''
        this.iconAnimation = ''
        this.messageIsActive = false
        // this.resetZIndex()
      }, 10000)
    },
    // async updateMessages (q) {
    //   if (!this.isInitialized) {
    //     this.isInitialized = true
    //     return
    //   }

    //   this.messages = q.docs.map(d => { return { ...d.data(), id: d.id} })
    //   // this.setZIndex()

    //   if (this.messages[0].class === 'sound') {
    //     this.playEmortSound(this.messages[0])
    //     return
    //   }

    //   this.messageIsActive = false

    //   // const distance = this.getDistanceFromMe()

    //   // const messageScale = 1.2 - distance / 300
    //   // console.log('messageScale', messageScale)
    //   // if (messageScale < 0.1) return

    //   await this.sleep(400)
    //   this.$emit('setIconAnimation', '')
    //   this.bubbleShape = `shape-${this.messages[0].type}`
    //   // this.bubbleShape = `shape-${this.user.bubbleType}`

    //   await this.sleep(100)
    //   // this.messageScale = messageScale
    //   this.latestMessage = this.messages[0]
    //   this.$emit('setIconAnimation', this.messages[0].type)
    //   // this.$emit('setIconAnimation', this.user.bubbleType)
    //   this.messageIsActive = true

    //   // play sounds
    //   // const msgPopSoundVol = ((0.5 - distance / 300) > 0.1) ?
    //   //   0.5 - distance / 300 : 0.1
    //   const msgPopSoundVol = 0.5
    //   this.$emit('playMsgPopSound', {
    //     id: this.latestMessage.type,
    //     volume: msgPopSoundVol
    //   })

    //   clearTimeout(this.messageActiveTimer)
    //   this.messageActiveTimer = setTimeout(() => {
    //     this.latestMessage = ''
    //     this.iconAnimation = ''
    //     this.messageIsActive = false
    //     // this.resetZIndex()
    //   }, 10000)
    // },
    async playEmortSound (targetSound) {
      // const targetSound = this.emortSounds
      //   .filter(e => e.id === this.user.playingSound.id)[0]
      
      if (targetSound) {
        // this.setZIndex()

        // reset
        this.currentPlayingEmortSound = null
        this.playingSoundIconAnimation = ''
        this.$emit('setIconAnimation', '')
        
        this.$emit('setIconAnimation', 'jump')
        // this.iconAnimation = 'jump'
        this.playingSoundIconAnimation = 'howahowaup'
        this.currentPlayingEmortSound = this.emortSounds
          .filter(e => e.id === targetSound.type)[0]
        
        // targetSound.audio.volume = 1.0
        // targetSound.audio.play()
        this.$emit('playEmortSound', {
          id: targetSound.type,
          volume: 0.5
        })
        
        await this.sleep(1000)

        // const soundIconScale = 1.2 - distance / 300
        const soundIconScale = 1.0
        
        this.soundIconScale = soundIconScale
        this.$emit('setIconAnimation', '')
        // this.iconAnimation = ''

        await this.sleep(1400) // 1000ms + x mx
        this.currentPlayingEmortSound = null
        this.playingSoundIconAnimation = ''

        // this.resetZIndex()
      }
    }
  }
}
</script>
